import { SET_MOBILE_AGENT } from 'actions';

export default (state = null, action) => {
  switch (action.type) {
    case SET_MOBILE_AGENT:
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/mobileAgent.js